// Types d'actions
export const UPLOAD_FILE_REQUEST = 'UPLOAD_FILE_REQUEST';
export const UPLOAD_FILE_SUCCESS = 'UPLOAD_FILE_SUCCESS';
export const UPLOAD_FILE_FAILURE = 'UPLOAD_FILE_FAILURE';

export const GET_FILE_REQUEST = 'GET_FILE_REQUEST';
export const GET_FILE_SUCCESS = 'GET_FILE_SUCCESS';
export const GET_FILE_FAILURE = 'GET_FILE_FAILURE';

export const DELETE_FILE_REQUEST = 'DELETE_FILE_REQUEST';
export const DELETE_FILE_SUCCESS = 'DELETE_FILE_SUCCESS';
export const DELETE_FILE_FAILURE = 'DELETE_FILE_FAILURE';

export const CLEAR_FILE_STATE = 'CLEAR_FILE_STATE';
export const CLEAR_FILE_ERROR = 'CLEAR_FILE_ERROR';

// État initial
const initialState = {
  currentFile: null,
  loading: false,
  error: null,
  uploadProgress: 0
};

// Reducer
const fileReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPLOAD_FILE_REQUEST:
    case GET_FILE_REQUEST:
    case DELETE_FILE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
      
    case UPLOAD_FILE_SUCCESS:
      return {
        ...state,
        currentFile: action.payload,
        loading: false,
        error: null,
        uploadProgress: 100
      };
      
    case GET_FILE_SUCCESS:
      return {
        ...state,
        currentFile: action.payload,
        loading: false,
        error: null
      };
      
    case DELETE_FILE_SUCCESS:
      return {
        ...state,
        currentFile: null,
        loading: false,
        error: null
      };
      
    case UPLOAD_FILE_FAILURE:
    case GET_FILE_FAILURE:
    case DELETE_FILE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        uploadProgress: 0
      };
      
    case CLEAR_FILE_STATE:
      return initialState;
      
    case CLEAR_FILE_ERROR:
      return {
        ...state,
        error: null
      };
      
    default:
      return state;
  }
};

export default fileReducer;